import { logger } from '../../../../utils/logger';
import { installJsSipUaEventListeners, installSipAutoAnswer } from '../audiocodes-sip';
import { installAgentLegCallInterceptor } from './agent-leg-interceptor';
import { installAudioCodeCallInterceptor } from './audiocode-call-interceptor';
import { installConnectAudioCodeInterceptor } from './connect-interceptor';

export function installCallDebugInterceptors(): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalWindow = window as any;

  const installInterceptors = () => {
    const webRtcService = globalWindow.__voiceClient?.webRtcService;
    const audioCode = webRtcService?.audioCode;

    if (!audioCode || !webRtcService) {
      return false;
    }

    if (webRtcService.__debugIntercepted) {
      return true;
    }

    logger.debug('[CXone DEBUG] Installing call debug interceptors...');

    installConnectAudioCodeInterceptor(webRtcService);
    installAgentLegCallInterceptor(webRtcService);
    installAudioCodeCallInterceptor(audioCode);

    installSipAutoAnswer(audioCode);
    installJsSipUaEventListeners(audioCode);

    webRtcService.__debugIntercepted = true;
    logger.debug('[CXone DEBUG] Call debug interceptors installed successfully');
    return true;
  };

  if (installInterceptors()) {
    return;
  }

  const checkInterval = setInterval(() => {
    if (installInterceptors()) {
      clearInterval(checkInterval);
    }
  }, 200);

  setTimeout(() => {
    clearInterval(checkInterval);
  }, 15000);
}
